<app-change-log
  [dataLoaded]="dataLoaded"
  [results]="changeLogResults"
  [hideExportBtn]="true"
  (pageChanged)="onPageChanged($event)">
</app-change-log>
